export default __webpack_public_path__ + "static/media/welcome.fd34240d.jpg";